<template>
  <div class="vame">
    <slot />
  </div>
</template>

<script>
import { Ticker } from 'pixi.js'

export default {
  provide () {
    return {
      vame: this,
      tickerHandler: undefined
    }
  },

  data () {
    return {
      ticker: new Ticker()
    }
  },

  mounted () {
    this.ticker.start()
    this.ticker.add(this.tickerHandler = this.tick.bind(this))
  },

  beforeDestroy () {
    this.ticker.destroy()
  },

  methods: {
    tick (delta) {
      this.$emit('update', delta)
    }
  }
}
</script>

<style lang="sass">
.vame
  display: flex
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  position: absolute
  overflow: hidden
  z-index: 1
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
</style>
